import BaseComponent from "../../BaseComponent";

/**
 * jQuery BlockUI; v20131009
 * http://jquery.malsup.com/block/
 * Copyright (c) 2013 M. Alsup; Dual licensed: MIT/GPL
 */
export default class PremiumBenefitsCard extends BaseComponent
{
    public init(): void {
        this.$component.find('.js-toggle').on('click', function() {
            const deactivate = $(this).data('deactivate');
            const hide = $(this).data('hide');
            const show = $(this).data('show');

            $(deactivate).removeClass('active');
            $(this).addClass('active');

            $(hide).addClass('hide');
            $(show).removeClass('hide');
        });

        const $contentMask = $('#echo-examples-mask');
        const contentBoxId = '#echo-examples-content';
        let currentHeight = this.getCurrentHeight(contentBoxId);
        $contentMask.css('height', currentHeight);

        $('.echo-thumbnail').on('click', () => {
            currentHeight = this.getCurrentHeight(contentBoxId);
            $contentMask.css('height', currentHeight);
        });
    }

    private getCurrentHeight(selector): number {
        return $(selector).height();
    }

}